import React from "react";

import TextField from "@mui/material/TextField";
import { Row, Col } from "react-bootstrap";

const convertTimeString = (date) => {
  return (
    padTo2Digits(new Date(date).getUTCHours()) +
    ":" +
    padTo2Digits(new Date(date).getUTCMinutes())
  );
};

const dayColMd = { span: 2 };
const timeColMd = { span: 2 };
const xs = { span: 6 };

const days = [
  { label: "Monday", prefix: "CCScheduleMon" },
  { label: "Tuesday", prefix: "CCScheduleTues" },
  { label: "Wednesday", prefix: "CCScheduleWed" },
  { label: "Thursday", prefix: "CCScheduleThur" },
  { label: "Friday", prefix: "CCScheduleFri" },
  { label: "Saturday", prefix: "CCScheduleSat" },
  { label: "Sunday", prefix: "CCScheduleSun" },
];

const timeFields = [
  { id: "overnightOpen", label: "AM Opening", suffix: "OvernightOpen" },
  {
    id: "overnightClose",
    label: "AM Closing",
    suffix: "OvernightClosed",
  },
  { id: "openTime", label: "PM Opening", suffix: "Open" },
  { id: "closeTime", label: "PM Closing", suffix: "Closed" },
];

const padTo2Digits = (num) => num.toString().padStart(2, "0");

const handleTimeChange = (e, field, props) => {
  let updatedTime = props.ClinicData[field]
    ? new Date(props.ClinicData[field])
    : new Date(null);
  updatedTime.setUTCHours(
    e.target.value.split(":")[0],
    e.target.value.split(":")[1]
  );
  props.SetClinicData((ClinicData) => ({
    ...ClinicData,
    ...{ [field]: updatedTime.toISOString() },
  }));
};

function OpenCloseTimes(props) {
  return (
    props.ClinicData && (
      <div key={props.ClinicData.DNIS}>
        <Row>
          <Col md={dayColMd}></Col>
          {timeFields.map((field) => (
            <Col
              key={field.id}
              style={{ fontWeight: "600", padding: "15px" }}
              md={timeColMd}
              xs={xs}
            >
              {field.label}
            </Col>
          ))}
        </Row>
        {days.map((day) => (
          <Row key={day.prefix}>
            <Col md={dayColMd} style={{ padding: "15px", fontWeight: "600" }}>
              {day.label}:
            </Col>
            {timeFields.map((field) => {
              const propertyName = `${day.prefix}${field.suffix}`;
              return (
                <Col key={`${day.prefix}-${field.id}`} md={timeColMd} xs={xs}>
                  <TextField
                    id={propertyName}
                    name={propertyName}
                    variant="outlined"
                    type="time"
                    onChange={(e) => handleTimeChange(e, propertyName, props)}
                    defaultValue={convertTimeString(
                      props.ClinicData[propertyName]
                    )}
                  />
                </Col>
              );
            })}
          </Row>
        ))}
      </div>
    )
  );
}

export default OpenCloseTimes;
